import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const CreateImpersonationLinkRequestDtoSchema = z.object({
  userId: z.number(),
});

const CreateImpersonationLinkResponseDtoSchema = z.object({
  url: z.string(),
});

export type CreateImpersonationLinkRequestDto = z.infer<
  typeof CreateImpersonationLinkRequestDtoSchema
>;
export type CreateImpersonationLinkResponseDto = z.infer<
  typeof CreateImpersonationLinkResponseDtoSchema
>;

export const createImpersonationLink = (
  dto: CreateImpersonationLinkRequestDto,
  config?: AxiosRequestConfig<CreateImpersonationLinkRequestDto>
) => {
  const data = CreateImpersonationLinkRequestDtoSchema.parse(dto);
  return api
    .post('/auth/impersonation-link', data, config)
    .then(responseContract(CreateImpersonationLinkResponseDtoSchema));
};
